import React, { Component } from 'react';
import Keycloak from 'keycloak-js';
import auth from './Auth'
import Home from "../views/home/Home"

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keycloak: null,
            authenticated: false
        }
    }

    componentDidMount() {
        const config = window.config;
        var keycloak = new Keycloak({
                                  realm: config.config_keycloak.realm,
                                  url: config.config_keycloak["auth-server-url"],
                                  clientId: config.config_keycloak.resource,
                       });


        if (this.props.location.state !== undefined){
            window.location.href = window.location.href +"?redirect="+ this.props.location.state.from.pathname;
        }

        keycloak.init({onLoad: 'login-required' , checkLoginIframe: false, promiseType: 'native'}).then(authenticated => {
                                                                                  this.setState({ keycloak: keycloak, authenticated: authenticated })
                                                                                  let appState = {
                                                                                                   authenticated: authenticated,
                                                                                                   keycloak: keycloak
                                                                                  };
                                                                                  auth.setToken(appState);
                                                                                  this.props.history.push(window.location.href.split("=")[1])
        });

  }

  render() {

      if (this.state.keycloak) {
          if (this.state.authenticated){
            return (
              <div className={"main"}>
                  <Home/>
              </div>
            );
          }
          else return (<div className={"main"}>Unable to authenticate!</div>);
      }
      return (
          <div className={"main"}>Redirecting to login...</div>
      );
  }

}


export default Login;
